// Import the functions you need from the SDKs you need
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCktSEHhtLotbJh_VmSJa1tDjnwlcJ9KSM",
  authDomain: "cricket-deploy.firebaseapp.com",
  projectId: "cricket-deploy",
  storageBucket: "cricket-deploy.firebasestorage.app",
  messagingSenderId: "506610894795",
  appId: "1:506610894795:web:ef0eb0c1abe1ab7db5d84e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

